<script>
import {Line} from 'vue-chartjs'
import moment from 'moment'
import API from '@/api/log'

export default {
  extends: Line,
  data() {
    return {
      accessCounts: { }
    };
  },
  computed: {
    graphMax() {
      if (this.accessCounts === undefined) { return 10; }
      const average = 1.0 * this.chartValues.reduce((a,v)=>a+v,0) / this.labels.length;
      const max = this.chartValues.reduce((a,v)=>v>a?v:a);
      const digitCount = Math.floor(average).toString().length;
      const topCount = average*1.7 > max*1.2 ? average*1.7 : max*1.2;
      return Math.max(Math.ceil(topCount / (10**(digitCount-1))) * 10**(digitCount-1), 10);
    },
    labels() {
      return Object.keys(this.accessCounts).sort();
    },
    chartValues() {
      return this.labels.map(l => this.accessCounts[l]);
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            borderColor: '#009CE1',
            borderWidth: 1.5,
            backgroundColor: 'rgba(0,156,225,0.05)',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#009CE1',
            data: this.chartValues
          }
        ]
      }
    },
    options() {
      return {
        legend: {
          display: false
        },
        tooltips: {
          mode: 'x-axis',
          intersect: false,
          position: 'nearest'
        },
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: "#999"
            }
          }],
          yAxes: [{
            ticks: {
              min: 0,
              max: this.graphMax,
              fontColor: "#999"
            }
          }]
        },
        maintainAspectRatio: false,
        spanGaps: true,
        elements: {
          line: {
            tension: 0
          }
        },
        plugins: {
          datalabels: {
            align: 'end',
            anchor: 'end',
            color: '#AAA',
            font: function(context) {
              return {
                size: 12
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.$emit('counts-updated', !this.checkEmpty());
    this.updateChartData();
  },
  methods: {
    checkEmpty: function () {
      return Object.values(this.accessCounts).every(v => v === 0)
    },
    updateChartData() {
      const that = this;
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().add(1, 'days').format('YYYY-MM-DD');
      API.getAccessCounts(from, to).then(function(response) {
        if (response && response.access_counts) {
          that.accessCounts = response.access_counts;
        } else {
          that.accessCounts = { };
        }
      });
    }
  },
  watch : {
    accessCounts : function() {
      this.$emit('counts-updated', !this.checkEmpty());
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
